module.exports = __webpack_public_path__ + "img/przelewy24.98798b3.png";